var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"mt-3",attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":12}},[_c('the-mask',{ref:"timeInput",staticClass:"timeCustom",attrs:{"mask":['##:##'],"placeholder":_vm.placeholder,"value":_vm.text}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }